import React, {useMemo} from 'react';
import {Map, List} from 'immutable';
import {Text, Button} from '@albert-io/atomic';

import AddClassroomsDropdown from './AddClassroomsDropdown.react';
import ClassroomTable from './ClassroomTable.react';

import {ClassroomAssignmentSettings} from './RecipientSettings.types';

import '../settings-modal.scss';

interface Props {
  selectedClassrooms: Map<string, ClassroomAssignmentSettings>;
  setSelectedClassrooms: (selectedClassrooms: Map<string, ClassroomAssignmentSettings>) => void;
  showClassDropdownPopover: boolean;
  setShowClassDropdownPopover: (showClassDropdownPopover) => void;
  popoverRef: Object;
  noSelectedClassesError: string;
  noDueDateClassIds: List<string>;
  showDueDateError: boolean;
  setShowDueDateError: (showDueDateError) => void;
}

const RecipientSettings = ({
  selectedClassrooms,
  setSelectedClassrooms,
  showClassDropdownPopover,
  setShowClassDropdownPopover,
  popoverRef,
  noSelectedClassesError,
  noDueDateClassIds,
  showDueDateError,
  setShowDueDateError
}: Props) => {
  const someClassroomHasDueDate = useMemo(() => {
    return (
      selectedClassrooms.toArray().length > 1 &&
      selectedClassrooms.some((classroom) => !!classroom?.dueDate && !!classroom?.dueDateTime)
    );
  }, [selectedClassrooms]);

  const copyDueDateToAll = () => {
    const firstClassroomDueDate = selectedClassrooms.find((classroom) => {
      return !!classroom?.dueDate && !!classroom?.dueDateTime;
    });

    let updatedClassrooms = selectedClassrooms;
    selectedClassrooms.forEach((classroom) => {
      const updatedClassroom = {
        ...classroom,
        dueDate: firstClassroomDueDate.dueDate,
        dueDateTime: firstClassroomDueDate.dueDateTime
      } as ClassroomAssignmentSettings;
      updatedClassrooms = updatedClassrooms.set(classroom?.classroomInfo.getId(), updatedClassroom);
    });
    setSelectedClassrooms(updatedClassrooms);
  };

  return (
    <div className='u-mar-b_8'>
      <div className='u-mar-t_4 u-mar-lr_4 u-display_flex u-justify-content_space-between'>
        <AddClassroomsDropdown
          selectedClassrooms={selectedClassrooms}
          setSelectedClassrooms={setSelectedClassrooms}
          popoverRef={popoverRef}
          showClassDropdownPopover={showClassDropdownPopover}
          setShowClassDropdownPopover={setShowClassDropdownPopover}
        />
        {someClassroomHasDueDate && (
          <Button variant='text' onClick={copyDueDateToAll}>
            Copy Due Date To All
          </Button>
        )}
      </div>
      {!selectedClassrooms.isEmpty() ? (
        <>
          <div className='u-mar-t_4 u-mar-b_2 u-mar-lr_4'>
            <ClassroomTable
              selectedClassrooms={selectedClassrooms}
              setSelectedClassrooms={setSelectedClassrooms}
              noDueDateClassIds={noDueDateClassIds}
              setShowDueDateError={setShowDueDateError}
            />
          </div>
          <div>
            {showDueDateError && (
              <Text color='red' className='u-mar-l_4 u-mar-t_2'>
                Choose a due date.
              </Text>
            )}
          </div>
        </>
      ) : (
        <Text as='div' color='red' className='u-mar-t_2 u-mar-l_4'>
          {noSelectedClassesError}
        </Text>
      )}
    </div>
  );
};

export default RecipientSettings;
